exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".k-pagination-options-btn{margin:0;margin-left:8px;min-width:0;padding-right:0;text-transform:capitalize}\n", ""]);

// exports
